<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Necessidade de Compra #{{ dados?.numero }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'compras-necessidades' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="q-ml-md">
      <section class="column text-brand-5 text-weight-bold">
        <span
          style="font-size: 16px"
          v-if="dados && dados.cod_integracao != null"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span>Pedido Suprimentos:</span>

          <div class="q-ml-xs row items-center">
            <q-input
              v-if="dados && dados.cod_integracao != null"
              class="q-ml-sm"
              label="Codigo Integração"
              v-model="dados.cod_integracao"
              dense
              outlined
              :disable="!editarCodIntegracao"
            />

            <q-icon
              v-if="dados && dados.cod_integracao != null"
              class="q-ml-sm cursor-pointer"
              :name="editarCodIntegracao ? 'close' : 'sym_o_edit'"
              @click="editarCodIntegracao = !editarCodIntegracao"
              size="sm"
              :color="editarCodIntegracao ? 'negative' : 'primary'"
            >
              <q-tooltip>
                {{ editarCodIntegracao ? "Cancelar edição" : "Editar Código" }}
              </q-tooltip>
            </q-icon>
          </div>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Criado por:</span>

          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{ dados?.usuario_nome }}</span>
          </span>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Urgência Definida:</span>

          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{ dados?.tag }}</span>
          </span>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Solicitante:</span>

          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{ dados?.solicitante_nome }}</span>
          </span>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Unidade de Controle:</span>

          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span
              >{{ dados?.cost_center_code }} ({{
                dados?.cost_center_name
              }})</span
            >
          </span>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
          v-if="dados?.cricao_necessidade"
        >
          <span style="min-width: 163px">Criada Em:</span>

          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{
              dados?.cricao_necessidade
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </span>
        </span>
        <span class="q-mt-sm text-brand-5 text-weight-bold row items-center">
          <span style="font-size: 16px" class="text-brand-1">
            <div v-if="dados?.voucher_id">
              Esta necessidade também gerou a requisição:
              <a
                class="target"
                @click="rota('requisicao-detalhe', dados?.voucher_id)"
                rel="noopener noreferrer"
                >{{ dados?.voucher_id }}</a
              >
            </div>
            <span class="text-brand-1" v-else>
              Esta necessidade não tem requisição vinculada.
            </span>
          </span>
        </span>
        <div class="col-2 q-mt-sm">
          <q-btn
            style="border-radius: 8px; background-color: #21324a; color: white"
            icon="list"
            no-caps
            label="Ver dados auxiliares"
            @click="modalNecessidade = true"
          />
        </div>
      </section>
    </div>

    <div v-if="produtosSemReferencia.length != 0" class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span> Produtos sem referência no catálogo </span>

        <q-btn
          @click="exportar"
          class="q-ml-sm"
          icon="file_upload"
          label="Exportar"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
        />
      </div>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        dense
        :rows="produtosSemReferencia"
        title-class="text-weight-bold text-brand-5"
        color="primary"
        class="tabela-tamanho-fixo"
        :columns="columns"
        :loading="disable"
        hide-pagination
        :rows-per-page-options="[0]"
        row-key="produto_nome"
      >
        <template #body-cell-editar="props">
          <q-td>
            <div class="row">
              <q-btn
                v-if="
                  props.row.editar == undefined || props.row.editar == false
                "
                @click="iniciarEdicao(props.row)"
                class=""
                icon="sym_o_edit"
                round
                flat
                color="primary"
              />

              <q-btn
                v-if="props.row.editar == true"
                @click="
                  editar(props.row), (props.row.editar = !props.row.editar)
                "
                class="q-ml-md"
                icon="check"
                round
                color="positive"
              />
            </div>
          </q-td>
        </template>

        <template #body-cell-responsavel_nome="props">
          <q-td>
            <div style="max-width: 240px" class="text-brand-5 text-weight-bold">
              <div v-if="props.row.editar" class="row items-center no-wrap">
                <q-btn
                  @click.stop="removerResponsavelItem(props.row)"
                  icon="sym_o_close"
                  round
                  flat
                  color="negative"
                  size="md"
                  dense
                  style="margin-left: -5px"
                >
                  <q-tooltip
                    anchor="top middle"
                    self="bottom middle"
                    class="bg-negative text-white"
                  >
                    Remover responsável
                  </q-tooltip>
                </q-btn>

                <SelectSolicitante
                  :lengthHidden="100"
                  label="Nome do Responsavel"
                  v-model="props.row.usuario"
                  class="col"
                />
              </div>
              <span v-else>{{ props.row.responsavel_nome }}</span>
            </div>
          </q-td>
        </template>

        <template #body-cell-quantidade_necessaria="props">
          <q-td>
            <div class="row text-brand-5 text-weight-bold">
              <q-input
                v-if="props.row.editar == true"
                style="margin-top: 20px"
                dense
                v-model="props.row.quantidadeNecessaria"
                outlined
                label="Quantidade"
                type="number"
                min="0"
                :rules="[(val) => val >= 0 || 'Quantidade deve ser positiva']"
                @update:model-value="
                  props.row.quantidadeOriginal = props.row.quantidade_necessaria
                "
              >
              </q-input>
              <span v-else>{{
                Number(props.row.quantidade_necessaria).toFixed(2)
              }}</span>
            </div>
          </q-td>
        </template>

        <template #body-cell-codigo="props">
          <q-td>
            <div class="row">
              <q-input
                style="min-width: 200px"
                class="col-md-2 col-4"
                dense
                v-model="props.row.codigo"
                outlined
                label="Codigo"
              >
              </q-input>
              <q-btn
                @click="editar(props.row)"
                class=""
                icon="sym_o_done"
                round
                flat
                color="positive"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-cost_center_code="props">
          <q-td>
            <div
              style="max-width: 240px"
              class="row text-brand-5 text-weight-bold"
            >
              <SelectCentroCustos
                label="Unid. Controle"
                v-if="props.row.editar == true"
                v-model="props.row.item_cost_center_code"
              />

              <span v-else>
                <div
                  v-if="
                    props.row.item_cost_center_code &&
                    props.row.item_cost_center_code.code
                  "
                >
                  {{ props.row.item_cost_center_code.code }}
                </div>
                <div v-else>{{ props.row.item_cost_center_code }}</div>
              </span>
            </div>
          </q-td>
        </template>
        <template #body-cell-delete="props">
          <q-td>
            <q-btn
              @click="deletar(props.row.uuid_item_fora_catalogo)"
              class=""
              icon="sym_o_delete"
              round
              flat
              color="negative"
            />
          </q-td>
        </template>
      </q-table>
    </div>

    <produtos-necessidade
      :data="itens"
      :info="info"
      @atualizar="atualizar"
      :get="get"
    />

    <div class="row col-12 align q-mt-md">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span> Arquivos da Necessidade </span>
      </div>
    </div>
    <section class="row align q-ml-md">
      <div class="col-2 row items-center">
        <div>
          <q-file label="Selecione o Arquivo" outlined dense v-model="file">
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </div>
      </div>

      <div>
        <q-btn
          no-caps
          icon="done"
          label="Enviar Arquivo"
          class="q-ml-sm"
          style="border-radius: 8px; background-color: #21324a; color: white"
          @click="enviarTemplate"
        />
      </div>
      <div>
        <q-btn
          no-caps
          class="q-ml-sm"
          icon="attach_file"
          label="Ver Arquivos"
          style="border-radius: 8px; background-color: #304f78; color: white"
          @click="getDocumentos"
        />
      </div>
    </section>

    <q-dialog v-model="documentos">
      <q-card style="width: 800px; max-width: 80vw; height: 80%">
        <q-card-section class="row justify-center">
          <div class="text-h6 text-brand-1 text-weight-bold">
            Documentos Enviados
          </div>
        </q-card-section>
        <q-separator />
        <ul class="col-12">
          <li
            class="text-brand-5"
            v-for="(documento, index) in listaDocumentos"
            :key="index"
          >
            <div class="row col-12 justify-between items-center q-mx-md">
              <div class="text-brand-1 text-weight-bold">
                {{ `Documento ${index + 1}` }}
              </div>
              <div>
                <q-btn
                  :href="documento.url"
                  round
                  flat
                  icon="sym_o_download"
                  style="color: #21324a"
                >
                </q-btn>
                <q-btn
                  dense
                  no-caps
                  flat
                  round
                  icon="sym_o_delete"
                  color="negative"
                  @click="deletarDocumento(documento.uuid)"
                ></q-btn>
              </div>
            </div>
          </li>
        </ul>
      </q-card>
    </q-dialog>

    <q-input
      v-if="dados"
      class="col-xs-11 q-mt-md"
      label="Observação da Necessidade"
      v-model="dados.observacao"
      dense
      filled
      type="textarea"
    />

    <dialog-info-design
      class="row col-12"
      mensagem="Detalhes Necessidade Compra"
      subMensagem="Os dados abaixo são para complementar os dados para auxiliar no processo de compras."
      :showConteudo="true"
      :width="'800px'"
      :showCancelar="true"
      :exibir="modalNecessidade"
      :desabilitarConfirme="
        dadosAuxiliares.data_aplicacao == '' ||
        dadosAuxiliares.justificativa_contratacao == ''
      "
      @resultado="alterarDadosAuxiliares"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="dadosAuxiliares.data_aplicacao"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dadosAuxiliares.data_aplicacao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Justificativa Contratação *
        </div>
        <q-input
          v-model="dadosAuxiliares.justificativa_contratacao"
          dense
          type="textarea"
          outlined
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
        <q-input
          v-model="dadosAuxiliares.detalhamento_tecnico"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Fornecedores
        </div>
        <q-input
          v-model="dadosAuxiliares.responsabilidades_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Contratante
        </div>
        <q-input
          v-model="dadosAuxiliares.responsabilidades_contratante"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
        <q-input
          v-model="dadosAuxiliares.possiveis_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
    </dialog-info-design>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "cost_center_code",
    label: "Unid. Controle",
    field: "cost_center_code",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "responsavel_nome",
    label: "Responsavel",
    field: "responsavel_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "produto_nome",
    label: "Produto",
    field: "produto_nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "unidade_medida",
    label: "Unid. Medida",
    field: "unidade_medida",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "quantidade_necessaria",
    label: "Qtd. de Compra	",
    field: "quantidade_necessaria",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "codigo",
    label: "Associar a Codigo",
    field: "codigo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
  },

  {
    name: "delete",
    label: "Remover",
    field: "delete",
    align: "left",
  },
];

import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ProdutosNecessidade from "../components/ProdutosNecessidade.vue";
import SelectSolicitante from "../components/SelectSolicitante.vue";
import SelectCentroCustos from "../components/SelectCentroCustos.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import { watchDebounced } from "@vueuse/core";
export default {
  components: {
    ProdutosNecessidade,
    SelectSolicitante,
    SelectCentroCustos,
    DialogInfoDesign,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const produtosSemReferencia = ref([]);
    const itens = ref([]);
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const documentos = ref(false);
    const file = ref("");
    const disable = ref(true);
    const id = route.params.id;
    const modalNecessidade = ref(false);
    const dadosAuxiliares = ref({
      data_aplicacao: "",
      detalhamento_tecnico: "",
      responsabilidades_fornecedores: "",
      responsabilidades_contratante: "",
      possiveis_fornecedores: "",
      justificativa_contratacao: "",
    });
    const dados = ref();
    const listaDocumentos = ref([]);
    const info = ref("");
    const get = ref(0);
    const editarCodIntegracao = ref(false);

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/acompanhar", {
          uuid: id,
        });

        dados.value = await response.data?.data[0];
        dadosAuxiliares.value = { ...response.data?.data[0] };

        if (dados.value?.cod_integracao === null) {
          dados.value.cod_integracao = "";
        }

        rows.value = response.data.data;

        if (rows.value.length == 0) {
          rows.value = produtosSemReferencia.value;
          dados.value = produtosSemReferencia.value[0];
          dadosAuxiliares.value = { ...produtosSemReferencia.value[0] };
        }

        if (dados.value?.data_aplicacao) {
          dadosAuxiliares.value.data_aplicacao =
            dadosAuxiliares.value.data_aplicacao
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/");
        }
        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const exportar = async () => {
      try {
        await store.dispatch("compras/exportarSemReferencia", {
          vendor_id: store.state.org.unidadeData.id,
          uuid: id,
          download: true,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarTemplate = async () => {
      if (file.value == "") {
        $q.notify({
          message: "O campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("compras/uploadAcompanhar", {
              arquivo: reader.result,
              uuid: id,
            });

            $q.notify({
              message: "Enviado com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });

            // Limpa a lista e força reload na próxima abertura
            listaDocumentos.value = [];
            getDados();
          } catch (error) {
            $q.notify({
              message: "Erro a o enviar",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };

        file.value = "";
      } catch (error) {
        console.log(error);

        file.value = "";
      }
    };

    const getDocumentos = async () => {
      documentos.value = true;

      try {
        let response = await store.dispatch("compras/getArquivosAcompanhar", {
          uuid: id,
          timestamp: Date.now(),
        });

        listaDocumentos.value = response.data.result.data;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar documentos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const setScNumero = async () => {
      try {
        const response = await store.dispatch("compras/setScNumero", {
          uuid: id,
          cod_integracao: dados.value.cod_integracao,
          observacao: dados.value.observacao,
        });
        info.value = response.data.result;

        itens.value = response.data.result.itens.products;

        $q.notify({
          message: "Observação atualizada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao atualizar observação",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getSemReferencia = async () => {
      try {
        const response = await store.dispatch("compras/getSemReferencia", {
          uuid: id,
        });

        produtosSemReferencia.value = await response.data.data;

        if (
          dados.value &&
          dados.value != "" &&
          produtosSemReferencia.value.length != 0
        ) {
          dados.value = await response.data.data[0];
          if (dados.value?.cod_integracao == null) {
            dados.value.cod_integracao = "";
          }
        }

        disable.value = false;
        getDados();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar produtos sem referencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getSemReferencia);

    const deletar = async (uuid) => {
      try {
        await store.dispatch("compras/deletarSemReferencia", {
          uuid: id,
          uuid_itens: [uuid],
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getSemReferencia();
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editar = async (dados) => {
      if (dados.codigo) {
        try {
          await store.dispatch("compras/editarSemReferenciaCodigo", {
            uuid: id,
            produtos: [
              {
                produto_fora_catalogo_uuid: dados.uuid_item_fora_catalogo,
                codigo: dados.codigo,
              },
            ],
          });
          get.value++;
          $q.notify({
            message: "Codigo Vinculado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getSemReferencia();
          getDados();
        } catch (error) {
          dados.codigo = "";
          $q.notify({
            message: "Codigo invalido!!",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }

      if (dados.quantidadeNecessaria !== dados.quantidadeOriginal) {
        try {
          await store.dispatch(
            "compras/editarProdutosNecessidadeQuantidadeForaCatalogo",
            {
              uuid: id,
              uuidItem: dados.uuid_item_fora_catalogo,
              quantidade: dados.quantidadeNecessaria,
            }
          );

          const index = produtosSemReferencia.value.findIndex(
            (p) => p.uuid_item_fora_catalogo === dados.uuid_item_fora_catalogo
          );
          if (index !== -1) {
            produtosSemReferencia.value[index].quantidade_necessaria =
              dados.quantidadeNecessaria;
          }

          await getSemReferencia();
          await getDados();
        } catch (error) {
          dados.quantidadeNecessaria = dados.quantidadeOriginal;

          const errorMessage =
            error.response?.data?.message ||
            "Você não tem permissão para editar a quantidade";

          $q.notify({
            message: errorMessage,
            color: "negative",
            timeout: 1000,
          });

          return;
        }
      }

      let item = {
        responsavel_id: dados.usuario?.id,
        cost_center_code: dados.item_cost_center_code?.code,
        quantidade: dados.quantidadeNecessaria,
      };

      if (
        item.responsavel_id != undefined ||
        item.responsavel_id != null ||
        item.quantidade != undefined
      ) {
        try {
          await store.dispatch("compras/editarSemReferencia", {
            uuid: dados.uuid_item_fora_catalogo,
            need_id: id,
            item: item,
          });

          $q.notify({
            message: "Editado com sucesso!",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getSemReferencia();
          getDados();
        } catch (error) {
          $q.notify({
            message:
              "Erro a o editar o Nome do responsavel precisa ser o Numero",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const iniciarEdicao = (row) => {
      row.editar = true;
      row.quantidadeOriginal = row.quantidade_necessaria;
      row.quantidadeNecessaria = row.quantidade_necessaria;
      row.responsavelOriginal = row.responsavel_id;
      row.centroCustoOriginal = row.item_cost_center_code?.code;
    };

    const removerResponsavelItem = async (item) => {
      try {
        await store.dispatch("compras/removerResponsavelSemReferencia", {
          uuid: id,
          uuidItem: item.uuid_item_fora_catalogo,
        });

        $q.notify({
          message: "Responsável removido com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getSemReferencia();
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao remover responsável",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const rota = async (rota, param = "") => {
      router.push({
        name: rota,
        params: { requisicaoId: param },
      });
    };

    const atualizar = async () => {
      getDados();
      getSemReferencia();
    };

    const alterarDadosAuxiliares = async (resultado) => {
      modalNecessidade.value = false;
      if (resultado) {
        try {
          await store.dispatch("compras/alterarDadosAuxiliares", {
            uuid: id,
            data_aplicacao: dadosAuxiliares?.value?.data_aplicacao
              ?.split("/")
              .reverse()
              .join("-"),
            detalhamento_tecnico: dadosAuxiliares.value.detalhamento_tecnico,
            responsabilidades_fornecedores:
              dadosAuxiliares.value.responsabilidades_fornecedores,
            responsabilidades_contratante:
              dadosAuxiliares.value.responsabilidades_contratante,
            possiveis_fornecedores:
              dadosAuxiliares.value.possiveis_fornecedores,
            justificativa_contratacao:
              dadosAuxiliares.value.justificativa_contratacao,
          });

          $q.notify({
            message: "Dados auxiliares alterados com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados();
        } catch (error) {
          $q.notify({
            message: `${error.response.data.message}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const deletarDocumento = async (uuid) => {
      try {
        await store.dispatch("compras/deletarArquivoAcompanhar", {
          uuid: uuid,
        });

        const index = listaDocumentos.value.findIndex(
          (doc) => doc.uuid === uuid
        );
        if (index !== -1) {
          listaDocumentos.value.splice(index, 1);
        }

        $q.notify({
          message: "Documento excluído com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao excluir documento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watchDebounced(
      () => dados.value?.cod_integracao,
      (newVal, oldVal) => {
        if (oldVal === undefined) return;
        if (newVal != "") {
          setScNumero();
        }
      },
      { debounce: 800 }
    );

    watchDebounced(
      () => dados.value?.observacao,
      (newVal, oldVal) => {
        if (oldVal === undefined) return;
        setScNumero();
      },
      { debounce: 800 }
    );

    return {
      dados,
      getDados,
      columns,
      rows,
      disable,
      info,
      exportar,
      file,
      enviarTemplate,
      getDocumentos,
      documentos,
      listaDocumentos,
      setScNumero,
      produtosSemReferencia,
      deletar,
      editar,
      rota,
      itens,
      getSemReferencia,
      atualizar,
      get,
      modalNecessidade,
      dadosAuxiliares,
      alterarDadosAuxiliares,
      editarCodIntegracao,
      removerResponsavelItem,
      iniciarEdicao,
      deletarDocumento,
    };
  },
};
</script>

<style scoped>
.q-table td:nth-child(1) {
  /* Primeira coluna */
  padding-right: 30px; /* Espaço maior após a coluna Unid. Controle */
}
.align {
  align-items: center;
}

.target {
  cursor: pointer;
  color: #4a93f8;
}
tbody tr td {
  white-space: pre-wrap;
}
a {
  text-decoration: none;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
